import { render, staticRenderFns } from "./ExternalPoll.vue?vue&type=template&id=05bb0a0a&scoped=true"
import script from "./ExternalPoll.vue?vue&type=script&lang=js"
export * from "./ExternalPoll.vue?vue&type=script&lang=js"
import style0 from "./ExternalPoll.vue?vue&type=style&index=0&id=05bb0a0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bb0a0a",
  null
  
)

export default component.exports